<template>
  <swiper ref="mySwiper" :options="swiperOption">
    <swiper-slide class="item" v-for="(item, index) in data" :key="index">
      <slot :item="item" name="slide-card"></slot>
    </swiper-slide>
    <div class="nav swiper-button-prev" slot="button-prev"></div>
    <div class="nav swiper-button-next" slot="button-next"></div>
  </swiper>
</template>
<script>
  import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
  import 'swiper/css/swiper.css'
  import video from '@fremcast/section/mixins/videos';
  export default {
    computed: {
      swiper() {
        return this.$refs.mySwiper.$swiper
      }
    },
    data() {
      return {
        swiperOption: {
          slidesPerView: 5,
          spaceBetween: 10,
          autoplay: {
            delay: this.settings.viewportCarouselBreakpointsProperties.default.autoplay
              ? this.settings.viewportCarouselBreakpointsProperties.default.delay * 1000
              : 999999999
          },
          //freeMode: true,
          breakpoints: {
            1920: {
              slidesPerView: this.settings.viewportCarouselBreakpointsProperties.extraLarge.columns,
              spaceBetween: this.settings.viewportCarouselBreakpointsProperties.extraLarge.spaceBetween
            },
            1024: {
              slidesPerView: this.settings.viewportCarouselBreakpointsProperties.large.columns,
              spaceBetween: this.settings.viewportCarouselBreakpointsProperties.large.spaceBetween
            },
            768: {
              slidesPerView: this.settings.viewportCarouselBreakpointsProperties.medium.columns,
              spaceBetween: this.settings.viewportCarouselBreakpointsProperties.medium.spaceBetween
            },
            640: {
              slidesPerView: this.settings.viewportCarouselBreakpointsProperties.small.columns,
              spaceBetween: this.settings.viewportCarouselBreakpointsProperties.small.spaceBetween
            },
            320: {
              slidesPerView: this.settings.viewportCarouselBreakpointsProperties.extraSmall.columns,
              spaceBetween: this.settings.viewportCarouselBreakpointsProperties.extraSmall.spaceBetween
            }
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        }
      }
    },
    props: {
      data: Array,
      settings: Object
    },
    mixins: [
      video
    ],
    components: {
      Swiper,
      SwiperSlide
    }
  }
</script>
<style scoped>

  .swiper-container {
    padding: 10px 0 10px 0;
  }

  .swiper-button-prev:after {
    font-size: 28px;
    font-weight: bold;
  }

  .swiper-button-prev {
    position: absolute;
    background: var(--v-primary-base) !important;
    border: none;
    color: #ffffff;
    top: 50%;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    transform: translateY(-50%);
  }

  .swiper-button-next:after {
    font-size: 28px;
    font-weight: bold;
  }

  .swiper-button-next {
    position: absolute;
    background: var(--v-primary-base) !important;
    border: none;
    color: #ffffff;
    top: 50%;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    transform: translateY(-50%);
  }
</style>
